export default class Impferinnerungstext {
    public impferinnerungstext_id: number | null = null;
    public bezeichnung: string | null = null;
    public text: string | null = null;
    public gueltig: string | null = 'j';

    constructor(data?: Partial<Impferinnerungstext>) {
        Object.assign(this, data);
    }
}
